module.exports = __webpack_public_path__ + "img/ag.2bf1a774.svg";